import { useTranslation } from "react-i18next";
import { Search } from "@/components/ui/combobox-search";
import { InputWithAlert } from "@/components/ui/input-with-alert";
import { getContractors } from "@/service/weexpertService";
import { GET_COUNTRY_NAME_BY_CODE, COUNTRY_TYPE_MAP } from "@/constants";

export const CounterpartySection = ({ form, inputChecked = false }) => {
  const { t } = useTranslation();
  const empty_error = t('empty_data_invalid');

  const {
    isViewMode,
    client,
    counterpartyName,
    counterpartyOrigin,
    counterpartyNip,
    counterpartyEmail,
    counterpartyType,
    counterpartyAddress,
    counterpartyPostIndex,
    counterpartyCity,
    counterpartyCountry,
    handleCounterpartySelect,
    canChangeCounterpartyOrRecipient,
    invoice,
  } = form;

  // View mode
  if (isViewMode) {
    return (
      <div className='w-full'>
        <div className="w-full text-xl font-medium py-6">
          {t("invoices:counterparty_info")}
        </div>
        <div className='w-full'>
          <div className='w-full flex justify-between flex-wrap'>
            <div className='w-full md:w-[49%] m-auto md:m-0'>
              <InputWithAlert
                label={t("common:counterparty")}
                value={invoice?.counterparty ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("common:origin")}
                value={invoice ? COUNTRY_TYPE_MAP(t)[invoice.counterpartyOrigin] ?? '' : ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("invoices:positions_name")}
                value={invoice?.counterpartyName ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label='NIP'
                value={invoice?.counterpartyNIP ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label='Email'
                value={invoice?.counterpartyEmail ?? 'N/A'}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
            </div>
            <div className='w-full md:w-[49%] m-auto md:m-0'>
              <InputWithAlert
                label={t("common:type")}
                value={invoice?.counterpartyType ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("common:address")}
                value={invoice?.counterpartyAddress ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("common:post_index")}
                value={invoice?.counterpartyPostIndex ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("common:city")}
                value={invoice?.counterpartyCity ?? ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
              <InputWithAlert
                label={t("common:country")}
                value={invoice ? GET_COUNTRY_NAME_BY_CODE(invoice.counterpartyCountry) : ''}
                readOnly={true}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Create/Edit mode
  return (
    <div className='w-full'>
      <div className="w-full text-xl font-medium py-6">
        {t("invoices:counterparty_info")}
      </div>
      <div className='w-full'>
        <div className='w-full flex justify-between flex-wrap'>
          <div className='w-full md:w-[49%] m-auto md:m-0'>
            {canChangeCounterpartyOrRecipient ? (
              <Search
                className={'pt-[10px]'}
                queryKey="counterparties"
                fetchOption={(query) => {
                  if (!client || !client.id) return [];
                  return getContractors(100, 0, query, [{ field: 'client', value: [client.id] }])
                    .then((res) => {
                      return res.data.counterparties.map(counterparty => ({
                        label: counterparty.name,
                        value: counterparty.id,
                        counterparty
                      }));
                    });
                }}
                placeholder={t("common:counterparty") + "*"}
                label={t("common:counterparty") + "*"}
                value={counterpartyName}
                error={inputChecked && !counterpartyName}
                errorMessage={empty_error}
                onChange={(e) => handleCounterpartySelect(e.counterparty)}
              />
            ) : (
              <InputWithAlert
                placeholder={t("phone")}
                value={counterpartyName ?? ''}
                label={t("common:counterparty") + "*"}
                onChange={() => {}}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
            )}
            <InputWithAlert
              placeholder={t("counterparties:origin")}
              value={counterpartyOrigin ?? ''}
              label={t("counterparties:origin")}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            {counterpartyType === 'COMPANY' && (
              <InputWithAlert
                placeholder={"NIP"}
                label="NIP"
                value={counterpartyNip ?? ''}
                onChange={() => {}}
                disabled
                inputClassName={'h-12 mt-2 mb-4 bg-white'}
              />
            )}
            <InputWithAlert
              placeholder={"Email"}
              label="Email"
              value={counterpartyEmail ?? ''}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
          </div>
          <div className='w-full md:w-[49%] m-auto md:m-0'>
            <InputWithAlert
              placeholder={t("common:type")}
              label={t("common:type")}
              value={counterpartyType ?? ''}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              placeholder={t("common:address")}
              label={t("common:address")}
              value={counterpartyAddress ?? ''}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              placeholder={t("common:post_index")}
              label={t("common:post_index")}
              value={counterpartyPostIndex ?? ''}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              placeholder={t("common:city")}
              label={t("common:city")}
              value={counterpartyCity ?? ''}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
            <InputWithAlert
              placeholder={t("common:country")}
              label={t("common:country")}
              value={GET_COUNTRY_NAME_BY_CODE(counterpartyCountry)}
              onChange={() => {}}
              disabled
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
